<template>
  <div style="padding-bottom: 50px">
    <div class="dataAnalysisActionPlan">
        <div id="radarChartContainer" v-show="data1.length>0">
          <div class="title">目标分数:{{data.targetScore}} &nbsp; 目标名次:{{data.targetRank}}</div>
          <div>
            <el-select v-model="selectValue1"  @change="selectValue1=='总成绩排名'?(type=1):options2.color?(type=2):null" placeholder="请选择">
              <el-option
                  v-for="(item,key) in selectOptions"
                  :key="key"
                  :label="item.value"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="selectValue2" v-if="selectValue1=='单科成绩排名'"  @change="selectValue3=''" placeholder="请选择">
              <el-option
                  v-for="(item,key) in semeterData"
                  :key="item.name"
                  :label="item.name"
                  :value="key+1" >
              </el-option>
            </el-select>
            <el-select v-model="selectValue3"  :disabled="!selectValue2" v-if="selectValue1=='单科成绩排名'"  @change="selectChange" placeholder="请选择">
              <el-option
                  v-for="(item,key) in semeterData[selectValue2-1]&&semeterData[selectValue2-1].children||[]"
                  :key="item.name"
                  :label="item.name"
                  :value="item.index">
              </el-option>
            </el-select>
            <div style="overflow: hidden" v-show="type==1">
              <ul class="colorList">
                <li>
                  <span style="background:#EE6900"></span>
                  初一上学期
                </li>
                <li>
                  <span style="background:#FA9800"></span>
                  初一下学期
                </li>
                <li>
                  <span style="background:#007CBF"></span>
                  初二上学期
                </li>
                <li>
                  <span style="background:#17ADE2"></span>
                  初二下学期
                </li>
                <li>
                  <span style="background:#0084A3"></span>
                  初三上学期
                </li>
                <li>
                  <span style="background:#00ADB0"></span>
                  初三下学期
                </li>
                <li>
                  <span style="background:#81AD40"></span>
                  高一上学期
                </li>
                <li>
                  <span style="background:#ABD24A"></span>
                  高一下学期
                </li>
                <li>
                  <span style="background:#706BA9"></span>
                  高二上学期
                </li>
                <li>
                  <span style="background:#A799C9"></span>
                  高二下学期
                </li>
                <li>
                  <span style="background:#FBC800"></span>
                  高三上学期
                </li>
                <li>
                  <span style="background:#F2ED00"></span>
                  高三下学期
                </li>
              </ul>
            </div>
            <div style="overflow:hidden">
              <ul class="colorList" style="max-width: 187px">
                <li>
                  成绩:柱状图
                </li>
                <li>
                  排名:折线图
                </li>
              </ul>
            </div>
          </div>
          <div id="radarChartContainerChart1" v-show="type==1">
          </div>
          <div id="radarChartContainerChart2"  style="height: 540px;margin-top: 20px" v-show="type==2">
          </div>
        </div>
        <div v-show="data1.length==0" class="noContent">
          <NoContent></NoContent>
        </div>
    </div>
  </div>
</template>

<script>
import NoContent from '@/components/NoContent.vue'
export default {
  name: "grade",
  components:{NoContent},
  data(){
    return{
      data:{},
      options:{},
      selectOptions:[
        {
          value:"总成绩排名"
        },
        {
          value:"单科成绩排名"
        }
      ],
      data1:[],
      data2:[],
      data3:[],
      data4:[],
      selectValue1:"总成绩排名",
      selectValue2:'',
      selectValue3:'',
      options2:{

      },
      type:1,
      semeterData:[],
      semeterIndex:'',
      semeterIndex2:0,
      boolSelect:true,
      type2:1,
      bool:true
    }
  },
  methods:{
    getData(){
      this.$ajax.post(this.G_acapi + this.ports.parent.student.dataAnalysis.grade, {
        type:1
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
          this.data=res.data.data;
            this.dataChange(res.data.data)
        } else {
        }
      })
    },
    selectData(grade,textName){
      this.$ajax.post(this.G_acapi + this.ports.parent.student.dataAnalysis.grade, {
        type:2,
        grade:grade,
        textName:textName,
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res => {
        if (res.data.code == 2000) {
          this.data=res.data.data;
          this.dataChange2(res.data.data)
        } else {
        }
      })
    },
    dataChange(data){
      const {semeterData}=this;
      let data1=[],data2=[],data3=[],data4=[],dataList=[],data5=[],dataColors=[],number=0
      Object.keys(data).forEach((key)=>{
        if(Array.isArray(data[key])&&(data[key].length>0)){
          let obj={}
          let  semester=null;
          if(key==0){
            semester='初一上学期';
            obj.index=1;
            obj.name='初一上学期';
            dataColors.push('#EE6900')
          }
          if(key==1){
            semester='初一下学期';
            obj.index=2;
            obj.name='初一下学期';
            dataColors.push('#FA9800')
          }
          if(key==2){
            semester='初二上学期';
            obj.index=3;
            obj.name='初二上学期';
            dataColors.push('#007CBF')
          }
          if(key==3){
            semester='初二下学期';
            obj.index=4;
            obj.name='初二下学期';
            dataColors.push('#17ADE2')
          }
          if(key==4){
            semester='初三上学期';
            obj.index=5;
            obj.name='初三上学期';
            dataColors.push('#0084A3')
          }
          if(key==5){
            semester='初三下学期';
            obj.index=6;
            obj.name='初三下学期';
            dataColors.push('#00ADB0')
          }
          if(key==6){
            semester='高一上学期';
            obj.index=7;
            obj.name='高一上学期';
            dataColors.push('#81AD40')
          }
          if(key==7){
            semester='高一下学期';
            obj.index=8;
            obj.name='高一下学期';
            dataColors.push('#ABD24A')
          }
          if(key==8){
            semester='高二上学期';
            obj.index=9;
            obj.name='高二上学期';
            dataColors.push('#706BA9')
          }
          if(key==9){
            semester='高二下学期';
            obj.index=10;
            obj.name='高二下学期';
            dataColors.push('#A799C9')
          }
          if(key==10){
            semester='高三上学期';
            obj.index=11;
            obj.name='高三上学期';
            dataColors.push('#FBC800')
          }
          if(key==11){
            semester='高三下学期';
            obj.index=12;
            obj.name='高三下学期';
            dataColors.push('#F2ED00')
          }
          obj.children=[]
          data[key].forEach((item2,key2)=>{
            let obj2={}
            if(item2.length!=0){
              if(key2==0){
                data1.push('第一次月考')
                obj2.index=1
                obj2.name='第一次月考'
              }
              if(key2==1){
                data1.push('第二次月考')
                obj2.index=2
                obj2.name='第二次月考'
              }
              if(key2==2){
                data1.push('第三次月考')
                obj2.index=3
                obj2.name='第三次月考'
              }
              if(key2==3){
                data1.push('第四次月考')
                obj2.index=4
                obj2.name='第四次月考'
              }

              dataList.push(item2)
              obj.children.push(obj2)
              data3.push(item2.totalScore)
              data4.push(item2.rank)
              data5.push(dataColors[number])
            }
          })
          number++;
          data2.push(semester)
          semeterData.push(obj)
        }
      })
      let dataListArr=[]
      dataList.forEach(item=>{
        let {chinese,mathematics,english,physics,chemistry,biology,history,geography,politics,totalScore,rank} = item;
        let obj={
          '总分':totalScore||0,
          '排名':rank||0,
          '语文':chinese||0,
          '数学':mathematics||0,
          '外语':english||0,
          '物理':physics||0,
          '化学':chemistry||0,
          '生物':biology||0,
          '历史':history||0,
          '地理':geography||0,
          '政治':politics||0,
        }
        dataListArr.push(obj)
      })
      this.semeterData=semeterData;
      this.data1=data1;
      this.data2=data2;
      this.data3=data3;
      this.data4=data4;
      this.$nextTick(()=>{
        this.draw(data1,data2,data3,data4,data5,dataListArr,dataColors)
      })
    },
    draw(data1,data2,data3,data4,data5,dataListArr,dataColors){
      let myChart = this.$echarts.init(document.getElementById('radarChartContainerChart1'));
      // 基于准备好的dom，初始化echarts实例
      let options={
          // legend: {
          //     data:['成绩','排名','66'],
          //     right:'4%'
          // },
          grid:{
            y2:100,
            left:'4%',
            right:'4%',
            top:'4%'
          },
          tooltip : {
            formatter(params){
              let str=''
              let data=dataListArr[params.dataIndex]
              for(let key in data){
                str+=key+':'+data[key]+'</br>'
              }
              return str
            },
            backgroundColor:'#F0F9FE',
            textStyle:{
              color:'#333'
            },
          },
          color:['#52C0FF','#FFB200'],
          xAxis: [{
            type: 'category',
            data:data1,
            axisLabel:{
              interval:0,
              rotate:60,
              formatter:function(value) {
                let str=value.slice(0,3)
                let str2=value.slice(3)
                return str+'\n'+str2
              },
              fontSize:12,
              align:'center',
              padding:[30,36,0,0],
              textStyle:{
                color:'#666666'
              }
            },
            axisLine: {
              lineStyle:{
                color:'#ccccccc'
              }
            }
          },
          ],
          yAxis: [
            {
              type: 'value',
              axisLine: {
                lineStyle:{
                  color:'#ECECEC'
                }
              },
              axisLabel:{
                textStyle:{
                  color:'#666666'
                }
              },
              max:1000,
              splitNumber:10
            },
            {
              type: 'value',
              splitLine:{
                show:false
              },
              axisLine: {
                lineStyle:{
                  color:'#cccccc'
                }
              },
              axisLabel:{
                textStyle:{
                  color:'#666666'
                },
                formatter: function(v){
                  if(v==0){
                    return 1
                  }else{
                    return v
                  }
                }
              },
              inverse:true,
              min:0,
              splitNumber:10,
              max:Math.ceil(Math.max(...data4)/100)*100,
            },
          ],
          series: [
            {
              name:'成绩',
              data: data3,
              type: 'bar',
              itemStyle: {
                normal: {
                  label: {
                    show: true,		//开启显示
                    position: 'top',	//在上方显示
                    textStyle: {	    //数值样式
                      color: '#666',
                      fontSize: 12
                    }
                  },
                  formatter:function (params){

                  },
                  color:function (params){
                    return data5[params.dataIndex]
                  },
                },
              },
              barMaxWidth:50,
              barMinWith:20,
            },
            {
              name:'排名',
              data: data4,
              type: 'line',
              yAxisIndex: 1,
              itemStyle: {
                normal: {
                  label: {
                    show: true,		//开启显示
                    position: 'top',	//在上方显示
                    textStyle: {	    //数值样式
                      color: '#666',
                      fontSize: 12
                    }
                  }
                }
              }
            }
          ],
          dataZoom: [
            {
              height: 14,
              type: "slider",
              show: true,
              xAxisIndex: [0],
              bottom: 0,
              start:0,
              end: 75,
              showDetail:false
            },
          ],
        }
      // 使用刚指定的配置项和数据显示图表。
      this.options=1
      myChart.setOption(options);
    },
    dataChange2(data){
      let data1=[],data2=[],data3=[]
      let {chinese,mathematics,english,physics,chemistry,biology,history,geography,politics}=data
      data1.push('语文','数学','外语','物理','化学','生物','历史','地理','政治')
      if(chinese){
        data2.push(chinese.score||0);
        data3.push(chinese.rank||0)
      }else{
        let index=data1.indexOf('语文')
        data1.splice(index,1)
      }
      if(mathematics){
        data2.push(mathematics.score||0);
        data3.push(mathematics.rank||0)
      }else{
        let index=data1.indexOf('数学')
        data1.splice(index,1)
      }
      if(english){
        data2.push(english.score||0);
        data3.push(english.rank||0)
      }else{
        let index=data1.indexOf('外语')
        data1.splice(index,1)
      }
      if(physics){
        data2.push(physics.score||0);
        data3.push(physics.rank||0)
      }else{
        let index=data1.indexOf('物理')
        data1.splice(index,1)
      }
      if(chemistry){
        data2.push(chemistry.score||0);
        data3.push(chemistry.rank||0)
      }else{
        let index=data1.indexOf('化学')
        data1.splice(index,1)
      }
      if(biology){
        data2.push(biology.score||0);
        data3.push(biology.rank||0)
      }else{
        let index=data1.indexOf('生物')
        data1.splice(index,1)
      }
      if(history){
        data2.push(history.score||0);
        data3.push(history.rank||0)
      }else{
        let index=data1.indexOf('历史')
        data1.splice(index,1)
      }
      if(geography){
        data2.push(geography.score||0);
        data3.push(geography.rank||0)
      }else{
        let index=data1.indexOf('地理')
        data1.splice(index,1)
      }
      if(politics){
        data2.push(politics.score||0);
        data3.push(politics.rank||0)
      }else{
        let index=data1.indexOf('政治')
        data1.splice(index,1)
      }
      this.draw2(data1,data2,data3)

    },
    draw2(data1,data2,data3){
      let myChart2 = this.$echarts.init(document.getElementById('radarChartContainerChart2'));
      // 基于准备好的dom，初始化echarts实例
      let options2={
        legend: {
          data:['成绩','排名'],
              right:'2%'
        },
        tooltip : {
          formatter(params){
            let index=params.dataIndex
            return '分数:'+data2[index]+'</br>'+'排名:'+data3[index]
          },
          backgroundColor:'#F0F9FE',
              textStyle:{
            color:'#333'
          }
        },
        grid:{
          y2:20,
              left:'4%',
              right:'4%'
        },
        color:['#52C0FF','#FFB200'],
            xAxis: [{
          type: 'category',
          data:data1,
          axisLabel:{
            interval:0,
            textStyle:{
              color:'#666666'
            }
          }
        },
        ],
            yAxis: [
          {
            type: 'value',
            axisLine: {
              lineStyle:{
                color:'#cccccc'
              }
            },
            axisLabel:{
              textStyle:{
                color:'#666666'
              }
            },
            max:150,
            min:0,
            splitNumber:10,
            interval: 15,
          },
          {
            type: 'value',
            splitLine:{
              show:false
            },
            axisLine: {
              lineStyle:{
                color:'#cccccc'
              }
            },
            axisLabel:{
              textStyle:{
                color:'#666666'
              },
              formatter: function(v){
                if(v==0){
                  return 1
                }else{
                  return v
                }
              }
            },
            inverse:true,
            min:0,
            splitNumber:10,
            max:Math.ceil(Math.max(...data3)/100)*100,
          }
        ],
            series: [
          {
            name:'成绩',
            data: data2,
            type: 'bar',
            itemStyle: {
              normal: {
                label: {
                  show: true,		//开启显示
                  position: 'top',	//在上方显示
                  textStyle: {	    //数值样式
                    color: '#666',
                    fontSize: 12
                  }
                }
              }
            },
            barMaxWidth:50,
            barMinWith:20
          },
          {
            name:'排名',
            data: data3,
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                label: {
                  show: true,		//开启显示
                  position: 'top',	//在上方显示
                  textStyle: {	    //数值样式
                    color: '#666',
                    fontSize: 12
                  }
                }
              }
            }
          }
        ],
      }
         // 使用刚指定的配置项和数据显示图表。
      this.options2=options2
         myChart2.setOption(options2);
    },
    selectChange(value){
      this.selectData(this.semeterData[this.selectValue2-1].index,value)
      this.type=2
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
    .dataAnalysisActionPlan{
        background: #fff;
        padding: 0 20px 30px;
        .title{
          font-size: 18px;
          font-weight: 600;
          color: #5C5C5C;
          line-height: 40px;
          margin-bottom: 10px;
        }
        table, th, td {
          border: 1px solid #CDE9F8;
          color: #5C5C5C;
          font-size: 14px;
        }
        table {
          font-size: 16px;
          border-collapse: collapse;
          width: 100%;
          text-align: center;
        }
        td,th{
          line-height: 44px;
        }
        th {
          background: #F0F9FE;
          font-weight: bold;
        }
        .border0{
          padding: 0;
          //vertical-align:text-top;
        }
        .table{
          border-style:hidden;
          border-width:0;
        }
        .table2{
          td{
            line-height: 22px;
          }
        }
        #radarChartContainer{
          width: 100%;
          -webkit-tap-highlight-color: transparent;
          user-select: none;
          position: relative;
          margin-bottom:80px;
        }
        .colorList{
          float: right;
          line-height: 30px;
          padding-right: 10px;
          width: 664px;
          li{
            float: left;
            span{
              display: inline-block;
              width: 15px;
              height: 8px;
              background: #52C0FF;
              margin-right: 5px;
              position: relative;
              top:-1px;
            }
            font-size:13px;
            color:#5C5C5C;
            margin-left:20px
          }
        }
      #radarChartContainerChart1,#radarChartContainerChart2{
        width: 100%;
        height: 520px;
      }
}
</style>
<style lang="less">
 .dataAnalysisActionPlan{
   .el-input--suffix{
     border: 1px solid #DCDFE6;
     margin-right: 20px;
     width: 160px;
   }
   .el-input__inner{
     line-height: 32px !important;
     height: 32px !important;
   }
   .el-icon-arrow-up{
     line-height: 32px;
   }
   .el-radio{
     margin-right: 10px;
   }
   .el-checkbox-group{
     label{
       display: block;
       margin-top: 14px;
     }
   }
 }
</style>